// ** React Imports
import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress'
import {
    Divider,
    IconButton,
    Tooltip,
    Fab,
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'

import Icon from '../../../components/icon';
import MsiDatagridDynamic from '../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../configs/constant';
import { useToast } from '../../../components/ToastProvider';

export default function Index() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast } = useToast();

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [listData, setListData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getData()
    }, [])

    const navigate = useNavigate();

    const getData = () => {
        setListData([])
        showToast("Loading", "loading");

        const url = apiUrl.apiUrl + '/hr/staff/list/' + cabang
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }


    const handleEdit = (row: any) => {
        navigate('/hr/staff/detail/' + row.id)
    };

    const handleDelete = (row: any) => {
        showToast("Loading", "loading");
        const url = apiUrl.apiUrl + '/hr/staff/delete/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast("Berhasil menghapus data", "success");
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    };

    const actionData = [
        {
            key: "cetak",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "cetak",
            align: "center",
            headerAlign: "center",
            headerName: "Cetak",
            caption: "Cetak Kartu",
            renderCell: (params: any) => (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Tooltip title="Cetak Kartu" placement="top">
                        <Box>
                            <IconButton onClick={() => window.open(apiUrl.baseUrl + '/hr/kartu-karyawan/' + params.id, '_blank')}>
                                <Icon icon="mdi:id-card" color="grey" />
                            </IconButton>
                        </Box>
                    </Tooltip>
                </Box>
            )
        },
    ];

    return (
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <div className={'content-block dx-card'}>
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                            <CardHeader title='MASTER STAFF' />
                        </Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mr: 2 }}>
                            <Fab color='primary' size='medium' onClick={() => navigate('/hr/staff/add')}
                            >
                                <Icon icon='mdi:plus' fontSize={35} color='white' />
                            </Fab>
                        </Box>
                    </Box>
                    <Divider />
                    {loading ? (
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', margin: 10 }}>
                            <CircularProgress disableShrink sx={{ mt: 6, height: '100%' }} />
                        </Grid>
                    ) : (
                        <MsiDatagridDynamic key={1} data={listData} hiddenColumns={['id', 'is_borongan', 'is_aktif', 'hrdivisi_id', 'hrjabatan_id']} title='MASTER STAFF' onEditRow={handleEdit} onDeleteRow={handleDelete} actions={actionData} />
                    )}
                </div>
            </Grid>
        </Grid>
    )
}
